// import React, { useState, useEffect } from 'react';

// import { ChevronRight, Code, Database, Settings, Layers, Book, Menu, X, Search, Home, CheckCircle, Play, Copy, Check, AlertCircle, Loader } from 'lucide-react';

// const LearningHub = () => {
//   const [selectedCategory, setSelectedCategory] = useState('python');
//   const [selectedTopic, setSelectedTopic] = useState('intro');
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [progress, setProgress] = useState({});
//   const [showCodeEditor, setShowCodeEditor] = useState(false);
//   const [copied, setCopied] = useState(false);
//   const [contentData, setContentData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [useLocalData, setUseLocalData] = useState(true); // Toggle for demo

//   // GitHub Configuration
//   const GITHUB_CONFIG = {
//     username: 'yourusername',  // Change this to your GitHub username
//     repository: 'learning-hub-content',  // Change this to your repo name
//     branch: 'main',
//     baseUrl: 'https://raw.githubusercontent.com'
//   };

//   // Navigation structure
//   const navigation = {
//     python: {
//       name: 'Python',
//       color: '#3776AB',
//       icon: <Code size={20} />,
//       topics: [
//         { id: 'home', name: 'Python HOME', icon: <Home size={16} /> },
//         { id: 'intro', name: 'Python Intro', icon: <Book size={16} /> },
//         { id: 'syntax', name: 'Python Syntax', icon: <Code size={16} /> },
//         { id: 'variables', name: 'Python Variables', icon: <Database size={16} /> },
//         { id: 'data-types', name: 'Python Data Types', icon: <Layers size={16} /> },
//         { id: 'numbers', name: 'Python Numbers', icon: <Layers size={16} /> },
//         { id: 'strings', name: 'Python Strings', icon: <Layers size={16} /> },
//         { id: 'operators', name: 'Python Operators', icon: <Settings size={16} /> },
//         { id: 'lists', name: 'Python Lists', icon: <Layers size={16} /> },
//         { id: 'tuples', name: 'Python Tuples', icon: <Layers size={16} /> },
//         { id: 'dictionaries', name: 'Python Dictionaries', icon: <Database size={16} /> },
//         { id: 'if-else', name: 'Python If...Else', icon: <ChevronRight size={16} /> },
//         { id: 'loops', name: 'Python Loops', icon: <ChevronRight size={16} /> },
//         { id: 'functions', name: 'Python Functions', icon: <Code size={16} /> },
//         { id: 'classes', name: 'Python Classes', icon: <Layers size={16} /> },
//         { id: 'file-handling', name: 'Python File Handling', icon: <Database size={16} /> }
//       ]
//     },
//     cpp: {
//       name: 'C++',
//       color: '#00599C',
//       icon: <Code size={20} />,
//       topics: [
//         { id: 'home', name: 'C++ HOME', icon: <Home size={16} /> },
//         { id: 'intro', name: 'C++ Intro', icon: <Book size={16} /> },
//         { id: 'syntax', name: 'C++ Syntax', icon: <Code size={16} /> },
//         { id: 'output', name: 'C++ Output', icon: <Layers size={16} /> },
//         { id: 'variables', name: 'C++ Variables', icon: <Database size={16} /> }
//       ]
//     },
//     java: {
//       name: 'Java',
//       color: '#007396',
//       icon: <Code size={20} />,
//       topics: [
//         { id: 'home', name: 'Java HOME', icon: <Home size={16} /> },
//         { id: 'intro', name: 'Java Intro', icon: <Book size={16} /> },
//         { id: 'syntax', name: 'Java Syntax', icon: <Code size={16} /> }
//       ]
//     }
//   };

//   // Local fallback data (demo purposes)
//   const localContentData = {
//     python: {
//       intro: {
//         title: 'Python Introduction',
//         content: [
//           {
//             type: 'text',
//             content: 'Python is a popular programming language. It was created by Guido van Rossum, and released in 1991.'
//           },
//           {
//             type: 'heading',
//             content: 'What is Python?'
//           },
//           {
//             type: 'text',
//             content: 'Python is a high-level, interpreted programming language with dynamic semantics. It is widely used for:'
//           },
//           {
//             type: 'list',
//             items: [
//               'Web development (server-side)',
//               'Software development',
//               'Mathematics and data analysis',
//               'System scripting',
//               'Artificial Intelligence and Machine Learning'
//             ]
//           },
//           {
//             type: 'heading',
//             content: 'Why Python?'
//           },
//           {
//             type: 'list',
//             items: [
//               'Python works on different platforms (Windows, Mac, Linux, Raspberry Pi, etc)',
//               'Python has a simple syntax similar to the English language',
//               'Python runs on an interpreter system, code can be executed immediately',
//               'Python can be treated in a procedural, object-oriented or functional way'
//             ]
//           },
//           {
//             type: 'note',
//             style: 'success',
//             content: 'Python is known for its readability and simple syntax, making it perfect for beginners!'
//           },
//           {
//             type: 'heading',
//             content: 'Python Example'
//           },
//           {
//             type: 'code',
//             code: 'print("Hello, World!")',
//             language: 'python',
//             tryItYourself: true
//           }
//         ]
//       },
//       syntax: {
//         title: 'Python Syntax',
//         content: [
//           {
//             type: 'text',
//             content: 'Python syntax can be executed by writing directly in the Command Line or by creating a python file.'
//           },
//           {
//             type: 'heading',
//             content: 'Python Indentation'
//           },
//           {
//             type: 'text',
//             content: 'Indentation refers to the spaces at the beginning of a code line. Python uses indentation to indicate a block of code.'
//           },
//           {
//             type: 'code',
//             code: `if 5 > 2:
//     print("Five is greater than two!")`,
//             language: 'python',
//             tryItYourself: true
//           },
//           {
//             type: 'note',
//             style: 'warning',
//             content: 'Python will give you an error if you skip the indentation!'
//           }
//         ]
//       },
//       variables: {
//         title: 'Python Variables',
//         content: [
//           {
//             type: 'text',
//             content: 'Variables are containers for storing data values. Python has no command for declaring a variable.'
//           },
//           {
//             type: 'code',
//             code: `x = 5
// y = "John"
// print(x)
// print(y)`,
//             language: 'python',
//             tryItYourself: true
//           }
//         ]
//       },
//       home: {
//         title: 'Python Tutorial',
//         content: [
//           {
//             type: 'banner',
//             content: 'Learn Python',
//             description: 'Python is a popular programming language.',
//             buttonText: 'Start learning Python now »'
//           },
//           {
//             type: 'heading',
//             content: 'Learning by Examples'
//           },
//           {
//             type: 'text',
//             content: 'With our "Try it Yourself" editor, you can edit Python code and view the result.'
//           },
//           {
//             type: 'code',
//             title: 'Example',
//             code: 'print("Hello, World!")',
//             language: 'python',
//             tryItYourself: true
//           }
//         ]
//       }
//     },
//     cpp: {
//       home: {
//         title: 'C++ Tutorial',
//         content: [
//           {
//             type: 'banner',
//             content: 'Learn C++',
//             description: 'C++ is a popular programming language.',
//             buttonText: 'Start learning C++ now »'
//           }
//         ]
//       },
//       intro: {
//         title: 'C++ Introduction',
//         content: [
//           {
//             type: 'text',
//             content: 'C++ is a popular programming language. C++ is used to create computer programs.'
//           },
//           {
//             type: 'code',
//             code: `#include <iostream>
// using namespace std;

// int main() {
//     cout << "Hello World!";
//     return 0;
// }`,
//             language: 'cpp',
//             tryItYourself: true
//           }
//         ]
//       }
//     },
//     java: {
//       home: {
//         title: 'Java Tutorial',
//         content: [
//           {
//             type: 'banner',
//             content: 'Learn Java',
//             description: 'Java is a popular programming language.',
//             buttonText: 'Start learning Java now »'
//           }
//         ]
//       },
//       intro: {
//         title: 'Java Introduction',
//         content: [
//           {
//             type: 'text',
//             content: 'Java is a popular programming language, created in 1995.'
//           },
//           {
//             type: 'code',
//             code: `public class Main {
//     public static void main(String[] args) {
//         System.out.println("Hello World");
//     }
// }`,
//             language: 'java',
//             tryItYourself: true
//           }
//         ]
//       }
//     }
//   };

//   // Fetch content from GitHub
//   const fetchContentFromGitHub = async (category, topic) => {
//     const url = `${GITHUB_CONFIG.baseUrl}/${GITHUB_CONFIG.username}/${GITHUB_CONFIG.repository}/${GITHUB_CONFIG.branch}/content/${category}/${topic}.json`;
    
//     try {
//       setLoading(true);
//       setError(null);
      
//       const response = await fetch(url);
      
//       if (!response.ok) {
//         throw new Error(`Failed to fetch content: ${response.status}`);
//       }
      
//       const data = await response.json();
      
//       // Cache the content
//       setContentData(prev => ({
//         ...prev,
//         [category]: {
//           ...prev[category],
//           [topic]: data
//         }
//       }));
      
//       setLoading(false);
//       return data;
//     } catch (err) {
//       console.error('Error fetching from GitHub:', err);
//       setError('Failed to load content from GitHub. Using local data.');
//       setLoading(false);
      
//       // Fallback to local data
//       return localContentData[category]?.[topic] || null;
//     }
//   };

//   // Load content when topic changes
//   useEffect(() => {
//     const loadContent = async () => {
//       // Check if content is already cached
//       if (contentData[selectedCategory]?.[selectedTopic]) {
//         return;
//       }

//       if (useLocalData) {
//         // Use local data for demo
//         setContentData(localContentData);
//       } else {
//         // Fetch from GitHub
//         await fetchContentFromGitHub(selectedCategory, selectedTopic);
//       }
//     };

//     loadContent();
//   }, [selectedCategory, selectedTopic, useLocalData]);

//   const getCurrentContent = () => {
//     const content = useLocalData 
//       ? localContentData[selectedCategory]?.[selectedTopic]
//       : contentData[selectedCategory]?.[selectedTopic];

//     return content || {
//       title: 'Content Not Found',
//       content: [{ 
//         type: 'text', 
//         content: 'This section is under development or content could not be loaded.' 
//       }]
//     };
//   };

//   const getTopicIndex = () => {
//     const topics = navigation[selectedCategory].topics;
//     return topics.findIndex(t => t.id === selectedTopic);
//   };

//   const goToNext = () => {
//     const topics = navigation[selectedCategory].topics;
//     const currentIndex = getTopicIndex();
//     if (currentIndex < topics.length - 1) {
//       setSelectedTopic(topics[currentIndex + 1].id);
//       window.scrollTo(0, 0);
//     }
//   };

//   const goToPrevious = () => {
//     const topics = navigation[selectedCategory].topics;
//     const currentIndex = getTopicIndex();
//     if (currentIndex > 0) {
//       setSelectedTopic(topics[currentIndex - 1].id);
//       window.scrollTo(0, 0);
//     }
//   };

//   const copyCode = (code) => {
//     navigator.clipboard.writeText(code);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 2000);
//   };

//   const renderContent = (item, index) => {
//     switch (item.type) {
//       case 'banner':
//         return (
//           <div key={index} className="alert border-0 shadow-sm mb-4" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
//             <h2 className="display-6 fw-bold mb-2">{item.content}</h2>
//             <p className="lead mb-3">{item.description}</p>
//             <button className="btn btn-light btn-lg">{item.buttonText}</button>
//           </div>
//         );
      
//       case 'heading':
//         return <h3 key={index} className="mt-4 mb-3 text-dark fw-bold">{item.content}</h3>;
      
//       case 'text':
//         return <p key={index} className="mb-3 text-dark" style={{ lineHeight: '1.8', fontSize: '16px' }}>{item.content}</p>;
      
//       case 'list':
//         return (
//           <div key={index} className="mb-3">
//             {item.title && <p className="fw-bold mb-2">{item.title}</p>}
//             <ul className="list-group list-group-flush">
//               {item.items.map((listItem, i) => (
//                 <li key={i} className="list-group-item border-0 ps-0">
//                   <CheckCircle size={16} className="text-success me-2" />
//                   {listItem}
//                 </li>
//               ))}
//             </ul>
//           </div>
//         );
      
//       case 'note':
//         return (
//           <div key={index} className={`alert alert-${item.style} border-0 shadow-sm mb-3`}>
//             <strong>Note:</strong> {item.content}
//           </div>
//         );
      
//       case 'code':
//         return (
//           <div key={index} className="mb-4">
//             {item.title && <h5 className="mb-2">{item.title}</h5>}
//             <div className="card border-0 shadow-sm">
//               <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
//                 <span className="font-monospace small">Example</span>
//                 <button className="btn btn-sm btn-outline-light" onClick={() => copyCode(item.code)}>
//                   {copied ? <Check size={16} /> : <Copy size={16} />}
//                   <span className="ms-1 d-none d-sm-inline">{copied ? 'Copied!' : 'Copy'}</span>
//                 </button>
//               </div>
//               <div className="card-body p-0">
//                 <pre className="mb-0 p-3" style={{ background: '#f8f9fa', overflowX: 'auto' }}>
//                   <code style={{ color: '#333', fontSize: '14px', fontFamily: 'Consolas, Monaco, monospace' }}>{item.code}</code>
//                 </pre>
//               </div>
//               {item.tryItYourself && (
//                 <div className="card-footer bg-white border-top">
//                   <button className="btn btn-success" onClick={() => setShowCodeEditor(true)}>
//                     <Play size={16} className="me-2" />
//                     Try it Yourself »
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         );
      
//       default:
//         return null;
//     }
//   };

//   useEffect(() => {
//     const style = document.createElement('style');
//     style.textContent = `
//       * { margin: 0; padding: 0; box-sizing: border-box; }
//       body { overflow: hidden; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; }
//       .sidebar-item { transition: all 0.2s ease; cursor: pointer; }
//       .sidebar-item:hover { background: #f0f0f0; transform: translateX(5px); }
//       .sidebar-item.active { background: #4CAF50; color: white; font-weight: bold; }
//     `;
//     document.head.appendChild(style);
//     return () => document.head.removeChild(style);
//   }, []);

//   const content = getCurrentContent();
//   const currentIndex = getTopicIndex();
//   const totalTopics = navigation[selectedCategory].topics.length;
//   const progressPercent = ((currentIndex + 1) / totalTopics) * 100;

//   return (
//     <div className='py-5 my-4' style={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', position:'relative' }}>
//       {/* Header */}
//       <nav className="navbar navbar-dark bg-dark shadow-sm" style={{ flexShrink: 0, zIndex: 1050 }}>
//         <div className="container-fluid px-3">
//           <button className="btn btn-link text-white d-lg-none p-0" onClick={() => setSidebarOpen(!sidebarOpen)} style={{ border: 'none' }}>
//             {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
//           </button>
//           <span className="navbar-brand mb-0 h5 mx-auto mx-lg-0">
//             <Book size={24} className="me-2" />
//             Learning Hub
//           </span>
//           <div className="d-none d-lg-flex gap-2 align-items-center">
//             {Object.entries(navigation).map(([key, cat]) => (
//               <button
//                 key={key}
//                 className={`btn btn-sm ${selectedCategory === key ? 'btn-light' : 'btn-outline-light'}`}
//                 onClick={() => { setSelectedCategory(key); setSelectedTopic('home'); }}
//                 style={{ textTransform: 'uppercase', fontWeight: 'bold' }}
//               >
//                 {cat.name}
//               </button>
//             ))}
//             <div className="form-check form-switch ms-3">
//               <input 
//                 className="form-check-input" 
//                 type="checkbox" 
//                 id="dataSourceToggle"
//                 checked={!useLocalData}
//                 onChange={(e) => setUseLocalData(!e.target.checked)}
//               />
//               <label className="form-check-label text-white small" htmlFor="dataSourceToggle">
//                 GitHub
//               </label>
//             </div>
//           </div>
//         </div>
//       </nav>

//       {/* Progress Bar */}
//       <div style={{ height: '4px', background: '#e0e0e0', flexShrink: 0 }}>
//         <div style={{ height: '100%', width: `${progressPercent}%`, background: '#4CAF50', transition: 'width 0.3s ease' }} />
//       </div>

//       {/* Error Alert */}
//       {error && (
//         <div className="alert alert-warning alert-dismissible fade show m-2 mb-0" role="alert">
//           <AlertCircle size={16} className="me-2" />
//           {error}
//           <button type="button" className="btn-close" onClick={() => setError(null)}></button>
//         </div>
//       )}

//       <div style={{ display: 'flex', flex: 1, overflow: 'hidden', position: 'relative' }}>
//         {/* Sidebar Overlay */}
//         {sidebarOpen && <div className="d-lg-none" onClick={() => setSidebarOpen(false)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 999 }} />}
        
//         {/* Sidebar */}
//         <div className={`bg-light border-end ${sidebarOpen ? 'd-block' : 'd-none'} d-lg-block`} style={{ width: '280px', flexShrink: 0, overflowY: 'auto', position: sidebarOpen ? 'fixed' : 'relative', top: sidebarOpen ? 0 : 'auto', bottom: sidebarOpen ? 0 : 'auto', left: 0, zIndex: 1000, height: '100%' }}>
//           <div className="p-3">
//             <h5 className="text-uppercase fw-bold mb-3" style={{ color: navigation[selectedCategory].color }}>
//               {navigation[selectedCategory].icon}
//               <span className="ms-2">{navigation[selectedCategory].name} Tutorial</span>
//             </h5>
            
//             <div className="d-lg-none mb-3">
//               <select className="form-select" value={selectedCategory} onChange={(e) => { setSelectedCategory(e.target.value); setSelectedTopic('home'); }}>
//                 {Object.entries(navigation).map(([key, cat]) => (
//                   <option key={key} value={key}>{cat.name}</option>
//                 ))}
//               </select>
//             </div>

//             {navigation[selectedCategory].topics.map((topic) => (
//               <div
//                 key={topic.id}
//                 className={`sidebar-item p-2 rounded mb-1 ${selectedTopic === topic.id ? 'active' : ''}`}
//                 onClick={() => { setSelectedTopic(topic.id); if (window.innerWidth < 992) setSidebarOpen(false); }}
//               >
//                 <div className="d-flex align-items-center">
//                   {topic.icon}
//                   <span className="ms-2 small">{topic.name}</span>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Main Content */}
//         <div className="flex-grow-1" style={{ overflowY: 'scroll', height: '100%', background: '#fff' }}>
//           <div className="container-fluid p-4" style={{ maxWidth: '900px' }}>
//             {loading ? (
//               <div className="text-center py-5">
//                 <Loader size={48} className="text-primary" style={{ animation: 'spin 1s linear infinite' }} />
//                 <p className="mt-3 text-muted">Loading content...</p>
//               </div>
//             ) : (
//               <>
//                 <h1 className="mb-4 fw-bold" style={{ color: navigation[selectedCategory].color }}>{content.title}</h1>
                
//                 {content.content.map((item, index) => renderContent(item, index))}

//                 {/* Navigation Buttons */}
//                 <div className="d-flex justify-content-between mt-5 pt-4 border-top">
//                   <button
//                     className="btn btn-outline-success"
//                     onClick={goToPrevious}
//                     disabled={currentIndex === 0}
//                   >
//                     « Previous
//                   </button>
//                   <button
//                     className="btn btn-success"
//                     onClick={goToNext}
//                     disabled={currentIndex === totalTopics - 1}
//                   >
//                     Next »
//                   </button>
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Code Editor Modal */}
//       {showCodeEditor && (
//         <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.8)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
//           <div className="bg-white rounded shadow-lg" style={{ width: '100%', maxWidth: '800px', maxHeight: '90vh', overflow: 'auto' }}>
//             <div className="p-3 bg-dark text-white d-flex justify-content-between align-items-center">
//               <h5 className="mb-0">Try it Yourself Editor</h5>
//               <button className="btn btn-sm btn-close btn-close-white" onClick={() => setShowCodeEditor(false)}></button>
//             </div>
//             <div className="p-4">
//               <p>Interactive code editor coming soon! This will allow you to run code in the browser.</p>
//               <button className="btn btn-secondary" onClick={() => setShowCodeEditor(false)}>Close</button>
//             </div>
//           </div>
//         </div>
//       )}

//       <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet" />
//       <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//     </div>
//   );
// };

// export default LearningHub;


// import React, { useState, useEffect } from 'react';
// import { ChevronDown, ChevronRight, Code, Copy, Check, Play, Menu, X, Search, Home } from 'lucide-react';

// const LearningHub = () => {
//   const [selectedSubject, setSelectedSubject] = useState('javascript');
//   const [selectedTopic, setSelectedTopic] = useState('syntax');
//   const [expandedSections, setExpandedSections] = useState(['basic']);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [copied, setCopied] = useState(false);
//   const [contentData, setContentData] = useState({});

//   // GitHub Configuration
//   const GITHUB_CONFIG = {
//     username: 'yourusername',
//     repository: 'learning-hub-content',
//     branch: 'main'
//   };

//   // All subjects with colors
//   const subjects = {
//     html: { name: 'HTML', color: '#E34C26', bg: '#fff5f5' },
//     css: { name: 'CSS', color: '#264de4', bg: '#f0f4ff' },
//     javascript: { name: 'JAVASCRIPT', color: '#F0DB4F', textColor: '#000', bg: '#fffef0' },
//     sql: { name: 'SQL', color: '#f29111', bg: '#fff8f0' },
//     python: { name: 'PYTHON', color: '#3776AB', bg: '#f0f7ff' },
//     java: { name: 'JAVA', color: '#f89820', bg: '#fff8f0' },
//     php: { name: 'PHP', color: '#777BB3', bg: '#f5f5ff' },
//     csharp: { name: 'C#', color: '#239120', bg: '#f0fff0' },
//     cpp: { name: 'C++', color: '#00599C', bg: '#f0f7ff' },
//     react: { name: 'REACT', color: '#61DAFB', textColor: '#000', bg: '#f0fcff' },
//     nodejs: { name: 'NODE.JS', color: '#68A063', bg: '#f5fff5' },
//     typescript: { name: 'TYPESCRIPT', color: '#3178C6', bg: '#f0f7ff' },
//     angular: { name: 'ANGULAR', color: '#DD0031', bg: '#fff5f5' },
//     vue: { name: 'VUE.JS', color: '#4FC08D', bg: '#f0fff5' },
//     django: { name: 'DJANGO', color: '#092E20', bg: '#f5fff5' },
//     flask: { name: 'FLASK', color: '#000000', bg: '#f5f5f5' },
//     spring: { name: 'SPRING', color: '#6DB33F', bg: '#f5fff5' },
//     mysql: { name: 'MYSQL', color: '#00758F', bg: '#f0f7ff' },
//     mongodb: { name: 'MONGODB', color: '#47A248', bg: '#f0fff0' },
//     postgresql: { name: 'POSTGRESQL', color: '#336791', bg: '#f0f7ff' },
//     redis: { name: 'REDIS', color: '#DC382D', bg: '#fff5f5' },
//     docker: { name: 'DOCKER', color: '#2496ED', bg: '#f0f7ff' },
//     kubernetes: { name: 'KUBERNETES', color: '#326CE5', bg: '#f0f7ff' },
//     aws: { name: 'AWS', color: '#FF9900', bg: '#fff8f0' },
//     azure: { name: 'AZURE', color: '#0089D6', bg: '#f0f7ff' },
//     git: { name: 'GIT', color: '#F05032', bg: '#fff5f5' },
//     linux: { name: 'LINUX', color: '#FCC624', textColor: '#000', bg: '#fffef0' },
//     rust: { name: 'RUST', color: '#CE422B', bg: '#fff5f5' },
//     go: { name: 'GO', color: '#00ADD8', bg: '#f0fcff' },
//     swift: { name: 'SWIFT', color: '#FA7343', bg: '#fff8f5' },
//     kotlin: { name: 'KOTLIN', color: '#7F52FF', bg: '#f5f5ff' },
//     ruby: { name: 'RUBY', color: '#CC342D', bg: '#fff5f5' },
//     scala: { name: 'SCALA', color: '#DC322F', bg: '#fff5f5' },
//     r: { name: 'R', color: '#276DC3', bg: '#f0f7ff' },
//     matlab: { name: 'MATLAB', color: '#e16737', bg: '#fff8f5' },
//     dart: { name: 'DART', color: '#0175C2', bg: '#f0f7ff' },
//     flutter: { name: 'FLUTTER', color: '#02569B', bg: '#f0f7ff' },
//     reactnative: { name: 'REACT NATIVE', color: '#61DAFB', textColor: '#000', bg: '#f0fcff' },
//     tensorflow: { name: 'TENSORFLOW', color: '#FF6F00', bg: '#fff8f0' },
//     pytorch: { name: 'PYTORCH', color: '#EE4C2C', bg: '#fff5f5' },
//     pandas: { name: 'PANDAS', color: '#150458', bg: '#f5f5ff' },
//     numpy: { name: 'NUMPY', color: '#013243', bg: '#f0f7ff' },
//     spark: { name: 'SPARK', color: '#E25A1C', bg: '#fff8f5' },
//     hadoop: { name: 'HADOOP', color: '#66CCFF', textColor: '#000', bg: '#f0fcff' },
//     jenkins: { name: 'JENKINS', color: '#D24939', bg: '#fff5f5' },
//     terraform: { name: 'TERRAFORM', color: '#7B42BC', bg: '#f5f5ff' },
//     ansible: { name: 'ANSIBLE', color: '#EE0000', bg: '#fff5f5' }
//   };

//   // Sidebar navigation structure
//   const sidebarStructure = {
//     javascript: {
//       'Basic JavaScript': ['tutorial', 'syntax', 'statements', 'comments', 'variables', 'operators', 'data-types', 'functions'],
//       'JS Control Flow': ['if-conditions', 'switch', 'loops', 'break-continue'],
//       'JS Objects': ['objects', 'properties', 'methods', 'constructors', 'prototypes'],
//       'JS Arrays': ['arrays', 'array-methods', 'array-sort', 'array-iteration'],
//       'JS Functions': ['function-definitions', 'function-parameters', 'function-invocation', 'closures'],
//       'JS Classes': ['classes', 'inheritance', 'static', 'encapsulation'],
//       'JS Async': ['callbacks', 'promises', 'async-await', 'fetch-api'],
//       'JS DOM': ['dom-intro', 'dom-methods', 'dom-events', 'event-listener']
//     },
//     python: {
//       'Python Tutorial': ['home', 'intro', 'get-started', 'syntax', 'comments', 'variables'],
//       'Python Basics': ['data-types', 'numbers', 'casting', 'strings', 'booleans', 'operators'],
//       'Python Collections': ['lists', 'tuples', 'sets', 'dictionaries'],
//       'Python Control Flow': ['if-else', 'while-loops', 'for-loops', 'functions', 'lambda'],
//       'Python OOP': ['classes', 'inheritance', 'iterators', 'scope', 'modules'],
//       'Python Advanced': ['dates', 'math', 'json', 'regex', 'exceptions'],
//       'Python File Handling': ['file-handling', 'read-files', 'write-files', 'delete-files']
//     },
//     java: {
//       'Java Tutorial': ['home', 'intro', 'get-started', 'syntax', 'output', 'comments', 'variables'],
//       'Java Basics': ['data-types', 'type-casting', 'operators', 'strings', 'math', 'booleans'],
//       'Java Control Flow': ['if-else', 'switch', 'while-loop', 'for-loop', 'break-continue'],
//       'Java Methods': ['methods', 'method-parameters', 'method-overloading', 'scope'],
//       'Java OOP': ['classes', 'constructors', 'modifiers', 'encapsulation', 'inheritance', 'polymorphism', 'abstraction'],
//       'Java Advanced': ['interface', 'enums', 'user-input', 'date', 'arraylist', 'hashmap']
//     },
//     cpp: {
//       'C++ Tutorial': ['home', 'intro', 'get-started', 'syntax', 'output', 'comments', 'variables'],
//       'C++ Basics': ['data-types', 'operators', 'strings', 'math', 'booleans', 'user-input'],
//       'C++ Control Flow': ['if-else', 'switch', 'while-loop', 'for-loop', 'break-continue'],
//       'C++ Functions': ['functions', 'function-parameters', 'function-overloading', 'recursion'],
//       'C++ OOP': ['classes', 'constructors', 'access-specifiers', 'encapsulation', 'inheritance', 'polymorphism'],
//       'C++ Advanced': ['arrays', 'pointers', 'references', 'files', 'exceptions']
//     }
//   };

//   // Mock content data (replace with GitHub fetch)
//   const mockContent = {
//     javascript: {
//       syntax: {
//         title: 'JavaScript Syntax',
//         sections: [
//           {
//             type: 'heading',
//             content: 'Syntax Rules'
//           },
//           {
//             type: 'text',
//             content: 'Syntax are the rules how programs must be constructed:'
//           },
//           {
//             type: 'code',
//             title: 'How to Declare Variables:',
//             code: `// How to Declare variables:
// let x = 5;
// let y = 6;

// // How to Compute values:
// let z = x + y;

// // I am a Comment. I do Nothing`,
//             language: 'javascript'
//           },
//           {
//             type: 'heading',
//             content: 'JavaScript Values'
//           },
//           {
//             type: 'text',
//             content: 'The JavaScript syntax defines two types of values:'
//           },
//           {
//             type: 'list',
//             items: [
//               'Fixed values (Literals)',
//               'Variable values (Variables)'
//             ]
//           },
//           {
//             type: 'heading',
//             content: 'JavaScript Variables'
//           },
//           {
//             type: 'text',
//             content: 'In a programming language, variables are used to store data values. JavaScript uses the keywords var, let and const to declare variables.'
//           },
//           {
//             type: 'code',
//             code: `let x;
// x = 6;`,
//             language: 'javascript'
//           }
//         ]
//       },
//       statements: {
//         title: 'JavaScript Statements',
//         sections: [
//           {
//             type: 'text',
//             content: 'A JavaScript program is a list of programming statements. In HTML, JavaScript programs are executed by the web browser.'
//           },
//           {
//             type: 'heading',
//             content: 'JavaScript Statements'
//           },
//           {
//             type: 'text',
//             content: 'JavaScript statements are composed of: Values, Operators, Expressions, Keywords, and Comments.'
//           },
//           {
//             type: 'code',
//             code: `let x, y, z;
// x = 5;
// y = 6;
// z = x + y;`,
//             language: 'javascript'
//           }
//         ]
//       }
//     },
//     python: {
//       syntax: {
//         title: 'Python Syntax',
//         sections: [
//           {
//             type: 'text',
//             content: 'Python syntax can be executed by writing directly in the Command Line or by creating a python file.'
//           },
//           {
//             type: 'heading',
//             content: 'Python Indentation'
//           },
//           {
//             type: 'text',
//             content: 'Indentation refers to the spaces at the beginning of a code line. Python uses indentation to indicate a block of code.'
//           },
//           {
//             type: 'code',
//             code: `if 5 > 2:
//     print("Five is greater than two!")`,
//             language: 'python'
//           }
//         ]
//       }
//     }
//   };

//   const toggleSection = (section) => {
//     setExpandedSections(prev =>
//       prev.includes(section)
//         ? prev.filter(s => s !== section)
//         : [...prev, section]
//     );
//   };

//   const copyCode = (code) => {
//     navigator.clipboard.writeText(code);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 2000);
//   };

//   const renderContent = (section, index) => {
//     switch (section.type) {
//       case 'heading':
//         return <h2 key={index} className="mt-4 mb-3 fw-bold" style={{ fontSize: '28px' }}>{section.content}</h2>;
      
//       case 'text':
//         return <p key={index} className="mb-3" style={{ lineHeight: '1.8', fontSize: '16px' }}>{section.content}</p>;
      
//       case 'list':
//         return (
//           <ul key={index} className="mb-3" style={{ lineHeight: '1.8' }}>
//             {section.items.map((item, i) => (
//               <li key={i}>{item}</li>
//             ))}
//           </ul>
//         );
      
//       case 'code':
//         return (
//           <div key={index} className="mb-4">
//             {section.title && <h5 className="mb-2">{section.title}</h5>}
//             <div className="card border-0 shadow-sm" style={{ background: '#E7F3ED' }}>
//               <div className="card-body p-0">
//                 <pre className="mb-0 p-3" style={{ background: '#E7F3ED', overflowX: 'auto' }}>
//                   <code style={{ color: '#000', fontSize: '15px', fontFamily: 'Consolas, Monaco, monospace', lineHeight: '1.6' }}>{section.code}</code>
//                 </pre>
//               </div>
//               <div className="card-footer bg-white border-top d-flex gap-2">
//                 <button className="btn btn-success btn-sm">
//                   <Play size={14} className="me-1" />
//                   Try it Yourself »
//                 </button>
//                 <button className="btn btn-light btn-sm" onClick={() => copyCode(section.code)}>
//                   {copied ? <Check size={14} /> : <Copy size={14} />}
//                 </button>
//               </div>
//             </div>
//           </div>
//         );
      
//       default:
//         return null;
//     }
//   };

//   const getCurrentContent = () => {
//     return mockContent[selectedSubject]?.[selectedTopic] || {
//       title: 'Content Coming Soon',
//       sections: [{ type: 'text', content: 'This section is under development.' }]
//     };
//   };

//   const getTopicsForSubject = () => {
//     return sidebarStructure[selectedSubject] || {};
//   };

//   const getAllTopics = () => {
//     const sections = getTopicsForSubject();
//     return Object.values(sections).flat();
//   };

//   const getTopicIndex = () => {
//     const allTopics = getAllTopics();
//     return allTopics.indexOf(selectedTopic);
//   };

//   const goToNext = () => {
//     const allTopics = getAllTopics();
//     const currentIndex = getTopicIndex();
//     if (currentIndex < allTopics.length - 1) {
//       setSelectedTopic(allTopics[currentIndex + 1]);
//       window.scrollTo(0, 0);
//     }
//   };

//   const goToPrevious = () => {
//     const allTopics = getAllTopics();
//     const currentIndex = getTopicIndex();
//     if (currentIndex > 0) {
//       setSelectedTopic(allTopics[currentIndex - 1]);
//       window.scrollTo(0, 0);
//     }
//   };

//   const content = getCurrentContent();
//   const currentSections = getTopicsForSubject();

//   useEffect(() => {
//     const style = document.createElement('style');
//     style.textContent = `
//       * { margin: 0; padding: 0; box-sizing: border-box; }
//       body { overflow: hidden; font-family: 'Segoe UI', 'Source Sans Pro', Calibri, Candara, Arial, sans-serif; }
//       .subject-tab { 
//         padding: 8px 16px; 
//         border: none; 
//         background: transparent; 
//         color: white; 
//         font-weight: 600; 
//         cursor: pointer; 
//         white-space: nowrap;
//         font-size: 14px;
//         transition: background 0.2s;
//       }
//       .subject-tab:hover { background: rgba(255,255,255,0.1); }
//       .subject-tab.active { background: #04AA6D; }
//       .sidebar-section-title {
//         cursor: pointer;
//         padding: 8px 16px;
//         background: #f1f1f1;
//         font-weight: 600;
//         font-size: 14px;
//         user-select: none;
//       }
//       .sidebar-section-title:hover { background: #e7e7e7; }
//       .sidebar-item {
//         padding: 8px 16px;
//         cursor: pointer;
//         font-size: 14px;
//         color: #000;
//         background: white;
//         border-left: 4px solid transparent;
//         transition: all 0.2s;
//       }
//       .sidebar-item:hover { background: #E7F3ED; border-left-color: #04AA6D; }
//       .sidebar-item.active { background: #04AA6D; color: white; border-left-color: #059862; font-weight: 600; }
//       .horizontal-scroll { 
//         overflow-x: auto; 
//         scrollbar-width: thin;
//       }
//       .horizontal-scroll::-webkit-scrollbar { height: 6px; }
//       .horizontal-scroll::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.3); border-radius: 3px; }
//     `;
//     document.head.appendChild(style);
//     return () => document.head.removeChild(style);
//   }, []);

//   return (
//     <div style={{ height: '100vh', marginTop:'80px', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
//       {/* Top Header */}
//       <div style={{ background: '#282A35', color: 'white', padding: '12px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//         <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
//           <button className="btn btn-link text-white d-lg-none p-0" onClick={() => setSidebarOpen(!sidebarOpen)} style={{ border: 'none' }}>
//             {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
//           </button>
//           <h4 className="mb-0" style={{ fontSize: '20px', fontWeight: '700' }}>
//             <Code size={24} className="me-2" style={{ verticalAlign: 'middle' }} />
//             Learning Hub
//           </h4>
//         </div>
//         <div className="d-none d-md-flex align-items-center gap-2">
//           <Search size={18} />
//           <input 
//             type="text" 
//             placeholder="Search..." 
//             style={{ 
//               border: 'none', 
//               background: 'rgba(255,255,255,0.1)', 
//               color: 'white', 
//               padding: '6px 12px', 
//               borderRadius: '4px',
//               outline: 'none'
//             }} 
//           />
//         </div>
//       </div>

//       {/* Horizontal Subject Tabs */}
//       <div style={{ background: '#282A35', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
//         <div className="horizontal-scroll" style={{ display: 'flex', padding: '0 10px' }}>
//           {Object.entries(subjects).map(([key, subject]) => (
//             <button
//               key={key}
//               className={`subject-tab ${selectedSubject === key ? 'active' : ''}`}
//               onClick={() => { 
//                 setSelectedSubject(key); 
//                 setSelectedTopic(sidebarStructure[key] ? Object.values(sidebarStructure[key])[0][0] : 'home');
//                 setExpandedSections([Object.keys(sidebarStructure[key] || {})[0]]);
//               }}
//             >
//               {subject.name}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
//         {/* Sidebar Overlay */}
//         {sidebarOpen && <div className="d-lg-none" onClick={() => setSidebarOpen(false)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 999 }} />}
        
//         {/* Sidebar */}
//         <div 
//           className={`${sidebarOpen ? 'd-block' : 'd-none'} d-lg-block`}
//           style={{ 
//             width: '250px', 
//             background: '#fff', 
//             borderRight: '1px solid #ddd',
//             overflowY: 'auto',
//             position: sidebarOpen ? 'fixed' : 'relative',
//             top: sidebarOpen ? 0 : 'auto',
//             bottom: sidebarOpen ? 0 : 'auto',
//             left: 0,
//             zIndex: 1000,
//             height: '100%'
//           }}
//         >
//           <div style={{ padding: '16px', background: subjects[selectedSubject]?.bg || '#f1f1f1', borderBottom: '1px solid #ddd' }}>
//             <h5 style={{ color: subjects[selectedSubject]?.color, fontWeight: '700', margin: 0 }}>
//               {subjects[selectedSubject]?.name} Tutorial
//             </h5>
//           </div>

//           {Object.entries(currentSections).map(([sectionName, topics]) => (
//             <div key={sectionName}>
//               <div 
//                 className="sidebar-section-title"
//                 onClick={() => toggleSection(sectionName)}
//               >
//                 <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                   <span>{sectionName}</span>
//                   {expandedSections.includes(sectionName) ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
//                 </div>
//               </div>
//               {expandedSections.includes(sectionName) && (
//                 <div>
//                   {topics.map(topic => (
//                     <div
//                       key={topic}
//                       className={`sidebar-item ${selectedTopic === topic ? 'active' : ''}`}
//                       onClick={() => {
//                         setSelectedTopic(topic);
//                         if (window.innerWidth < 992) setSidebarOpen(false);
//                       }}
//                     >
//                       {topic.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>

//         {/* Main Content */}
//         <div style={{ flex: 1, overflowY: 'auto', background: '#fff' }}>
//           <div style={{ maxWidth: '900px', padding: '40px 20px', margin: '0 auto' }}>
//             {/* Previous Button */}
//             <button 
//               className="btn btn-success mb-3"
//               onClick={goToPrevious}
//               disabled={getTopicIndex() === 0}
//               style={{ minWidth: '100px' }}
//             >
//               ❮ Previous
//             </button>

//             <h1 style={{ fontSize: '42px', fontWeight: '400', marginBottom: '20px' }}>{content.title}</h1>
            
//             {content.sections?.map((section, index) => renderContent(section, index))}

//             {/* Navigation Buttons */}
//             <div className="d-flex justify-content-between mt-5 pt-4">
//               <button 
//                 className="btn btn-outline-success"
//                 onClick={goToPrevious}
//                 disabled={getTopicIndex() === 0}
//                 style={{ minWidth: '120px' }}
//               >
//                 ❮ Previous
//               </button>
//               <button 
//                 className="btn btn-success"
//                 onClick={goToNext}
//                 disabled={getTopicIndex() === getAllTopics().length - 1}
//                 style={{ minWidth: '120px' }}
//               >
//                 Next ❯
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet" />
//     </div>
//   );
// };

// export default LearningHub;


import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronRight, Code, Copy, Check, Play, Menu, X, Search, Loader, AlertCircle } from 'lucide-react';
import { FaBookReader } from 'react-icons/fa';

const LearningHub = () => {
  const [selectedSubject, setSelectedSubject] = useState('html');
  const [selectedTopic, setSelectedTopic] = useState('intro');
  const [expandedSections, setExpandedSections] = useState(['HTML Tutorial']);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [contentData, setContentData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // GitHub Configuration - CHANGE THESE TO YOUR REPO
  const GITHUB_CONFIG = {
    username: 'yourusername',  // Change to your GitHub username
    repository: 'learning-hub-content',  // Your repo name
    branch: 'main',
    baseUrl: 'https://raw.githubusercontent.com'
  };

  // All subjects
  const subjects = {
    html: { name: 'HTML', color: '#E34C26', bg: '#fff5f5' },
    css: { name: 'CSS', color: '#264de4', bg: '#f0f4ff' },
    javascript: { name: 'JAVASCRIPT', color: '#F0DB4F', textColor: '#000', bg: '#fffef0' },
    sql: { name: 'SQL', color: '#f29111', bg: '#fff8f0' },
    python: { name: 'PYTHON', color: '#3776AB', bg: '#f0f7ff' },
    java: { name: 'JAVA', color: '#f89820', bg: '#fff8f0' },
    php: { name: 'PHP', color: '#777BB3', bg: '#f5f5ff' },
    csharp: { name: 'C#', color: '#239120', bg: '#f0fff0' },
    cpp: { name: 'C++', color: '#00599C', bg: '#f0f7ff' },
    react: { name: 'REACT', color: '#61DAFB', textColor: '#000', bg: '#f0fcff' },
    nodejs: { name: 'NODE.JS', color: '#68A063', bg: '#f5fff5' },
    typescript: { name: 'TYPESCRIPT', color: '#3178C6', bg: '#f0f7ff' },
    angular: { name: 'ANGULAR', color: '#DD0031', bg: '#fff5f5' },
    vue: { name: 'VUE.JS', color: '#4FC08D', bg: '#f0fff5' },
    django: { name: 'DJANGO', color: '#092E20', bg: '#f5fff5' },
    mysql: { name: 'MYSQL', color: '#00758F', bg: '#f0f7ff' },
    mongodb: { name: 'MONGODB', color: '#47A248', bg: '#f0fff0' },
    docker: { name: 'DOCKER', color: '#2496ED', bg: '#f0f7ff' },
    kubernetes: { name: 'KUBERNETES', color: '#326CE5', bg: '#f0f7ff' },
    aws: { name: 'AWS', color: '#FF9900', bg: '#fff8f0' },
    git: { name: 'GIT', color: '#F05032', bg: '#fff5f5' },
    rust: { name: 'RUST', color: '#CE422B', bg: '#fff5f5' },
    go: { name: 'GO', color: '#00ADD8', bg: '#f0fcff' },
    swift: { name: 'SWIFT', color: '#FA7343', bg: '#fff8f5' },
    kotlin: { name: 'KOTLIN', color: '#7F52FF', bg: '#f5f5ff' }
  };

  // Sidebar structure
  const sidebarStructure = {
    html: {
      'HTML Tutorial': ['intro', 'editors', 'basic', 'elements', 'attributes', 'headings', 'paragraphs', 'styles', 'formatting', 'quotations', 'comments', 'colors', 'css', 'links', 'images', 'favicon', 'tables', 'lists', 'block-inline', 'classes', 'id', 'iframes', 'javascript', 'file-paths', 'head', 'layout', 'responsive', 'computercode', 'semantics', 'style-guide', 'entities', 'symbols', 'emojis', 'charset', 'url-encode', 'vs-xhtml'],
      'HTML Forms': ['forms', 'form-attributes', 'form-elements', 'input-types', 'input-attributes', 'input-form-attributes'],
      'HTML Graphics': ['canvas', 'svg'],
      'HTML Media': ['media', 'video', 'audio', 'plug-ins', 'youtube'],
      'HTML APIs': ['geolocation', 'drag-drop', 'web-storage', 'web-workers', 'sse']
    },
    javascript: {
      'Basic JavaScript': ['intro', 'syntax', 'statements', 'comments', 'variables', 'operators', 'data-types', 'functions'],
      'JS Control Flow': ['if-conditions', 'switch', 'loops', 'break-continue'],
      'JS Objects': ['objects', 'properties', 'methods', 'constructors'],
      'JS Functions': ['function-definitions', 'closures', 'callbacks'],
      'JS Async': ['promises', 'async-await', 'fetch-api']
    },
    python: {
      'Python Tutorial': ['intro', 'get-started', 'syntax', 'comments', 'variables'],
      'Python Basics': ['data-types', 'numbers', 'strings', 'operators'],
      'Python Collections': ['lists', 'tuples', 'sets', 'dictionaries'],
      'Python OOP': ['classes', 'inheritance', 'modules']
    }
  };

  // Fetch content from GitHub
  const fetchFromGitHub = async (subject, topic) => {
    const url = `${GITHUB_CONFIG.baseUrl}/${GITHUB_CONFIG.username}/${GITHUB_CONFIG.repository}/${GITHUB_CONFIG.branch}/content/${subject}/${topic}.json`;
    
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error('Content not found');
      }
      
      const data = await response.json();
      
      // Cache content
      setContentData(prev => ({
        ...prev,
        [subject]: {
          ...prev[subject],
          [topic]: data
        }
      }));
      
      setLoading(false);
      return data;
    } catch (err) {
      console.error('GitHub fetch error:', err);
      setError(`Failed to load content. Make sure the file exists at: content/${subject}/${topic}.json`);
      setLoading(false);
      return null;
    }
  };

  // Load content when topic changes
  useEffect(() => {
    const loadContent = async () => {
      if (contentData[selectedSubject]?.[selectedTopic]) {
        return; // Already cached
      }
      await fetchFromGitHub(selectedSubject, selectedTopic);
    };
    loadContent();
  }, [selectedSubject, selectedTopic]);

  const toggleSection = (section) => {
    setExpandedSections(prev =>
      prev.includes(section) ? prev.filter(s => s !== section) : [...prev, section]
    );
  };

  const copyCode = (code) => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const renderContent = (section, index) => {
    switch (section.type) {
      case 'heading':
        return <h2 key={index} className="mt-4 mb-3 fw-bold" style={{ fontSize: '28px' }}>{section.content}</h2>;
      
      case 'text':
        return <p key={index} className="mb-3" style={{ lineHeight: '1.8', fontSize: '16px' }}>{section.content}</p>;
      
      case 'list':
        return (
          <ul key={index} className="mb-3" style={{ lineHeight: '1.8' }}>
            {section.items.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        );
      
      case 'note':
        return (
          <div key={index} className={`alert alert-${section.style || 'info'} mb-3`}>
            {section.content}
          </div>
        );

      case 'example':
        return (
          <div key={index} className="card mb-4 border-0 shadow-sm">
            {section.title && (
              <div className="card-header bg-light">
                <strong>Example</strong>
                {section.title && `: ${section.title}`}
              </div>
            )}
            <div className="card-body p-0">
              <pre className="mb-0 p-3" style={{ background: '#E7F3ED', overflowX: 'auto' }}>
                <code style={{ color: '#000', fontSize: '15px', fontFamily: 'Consolas, Monaco, monospace', lineHeight: '1.6' }}>
                  {section.code}
                </code>
              </pre>
            </div>
            <div className="card-footer bg-white border-top d-flex gap-2">
              <button className="btn btn-success btn-sm" onClick={() => window.open('https://www.w3schools.com/tryit/', '_blank')}>
                <Play size={14} className="me-1" />
                Try it Yourself »
              </button>
              <button className="btn btn-light btn-sm" onClick={() => copyCode(section.code)}>
                {copied ? <Check size={14} /> : <Copy size={14} />}
              </button>
            </div>
          </div>
        );
      
      default:
        return null;
    }
  };

  const getCurrentContent = () => {
    return contentData[selectedSubject]?.[selectedTopic] || null;
  };

  const getAllTopics = () => {
    const sections = sidebarStructure[selectedSubject] || {};
    return Object.values(sections).flat();
  };

  const getTopicIndex = () => getAllTopics().indexOf(selectedTopic);

  const goToNext = () => {
    const topics = getAllTopics();
    const idx = getTopicIndex();
    if (idx < topics.length - 1) {
      setSelectedTopic(topics[idx + 1]);
      window.scrollTo(0, 0);
    }
  };

  const goToPrevious = () => {
    const topics = getAllTopics();
    const idx = getTopicIndex();
    if (idx > 0) {
      setSelectedTopic(topics[idx - 1]);
      window.scrollTo(0, 0);
    }
  };

  const content = getCurrentContent();
  const currentSections = sidebarStructure[selectedSubject] || {};

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      * { margin: 0; padding: 0; box-sizing: border-box; }
      body { overflow: hidden; font-family: 'Segoe UI', 'Source Sans Pro', Calibri, Arial, sans-serif; }
      .subject-tab { 
        padding: 8px 16px; border: none; background: transparent; color: white; 
        font-weight: 600; cursor: pointer; white-space: nowrap; font-size: 14px;
        transition: background 0.2s;
      }
      .subject-tab:hover { background: rgba(255,255,255,0.1); }
      .subject-tab.active { background: #04AA6D; }
      .sidebar-section-title {
        cursor: pointer; padding: 8px 16px; background: #f1f1f1;
        font-weight: 600; font-size: 14px; user-select: none;
      }
      .sidebar-section-title:hover { background: #e7e7e7; }
      .sidebar-item {
        padding: 8px 16px; cursor: pointer; font-size: 14px; color: #000;
        background: white; border-left: 4px solid transparent; transition: all 0.2s;
      }
      .sidebar-item:hover { background: #E7F3ED; border-left-color: #04AA6D; }
      .sidebar-item.active { background: #04AA6D; color: white; border-left-color: #059862; font-weight: 600; }
      .horizontal-scroll { overflow-x: auto; scrollbar-width: thin; }
      .horizontal-scroll::-webkit-scrollbar { height: 6px; }
      .horizontal-scroll::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.3); border-radius: 3px; }
      @keyframes spin { to { transform: rotate(360deg); } }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <div style={{ height: '100vh',marginTop:'80px', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {/* Header */}
      <div style={{ background: '#282A35', color: 'white', padding: '12px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <button className="btn btn-link text-white d-lg-none p-0" onClick={() => setSidebarOpen(!sidebarOpen)} style={{ border: 'none' }}>
            {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
          <h4 className="mb-0" style={{ fontSize: '20px', fontWeight: '700' }}>
            <FaBookReader size={24} className="me-3" style={{ verticalAlign: 'middle' }} />
            Olewin Academy Learning Hub
          </h4>
        </div>
        <div className="d-none d-md-flex align-items-center gap-2">
          <Search size={18} />
          <input 
            type="text" 
            placeholder="Search..." 
            style={{ border: 'none', background: 'rgba(255,255,255,0.1)', color: 'white', padding: '6px 12px', borderRadius: '4px', outline: 'none' }} 
          />
        </div>
      </div>

      {/* Subject Tabs */}
      <div style={{ background: '#282A35', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="horizontal-scroll" style={{ display: 'flex', padding: '0 10px' }}>
          {Object.entries(subjects).map(([key, subject]) => (
            <button
              key={key}
              className={`subject-tab ${selectedSubject === key ? 'active' : ''}`}
              onClick={() => { 
                setSelectedSubject(key); 
                const firstSection = sidebarStructure[key];
                const firstTopic = firstSection ? Object.values(firstSection)[0][0] : 'intro';
                setSelectedTopic(firstTopic);
                setExpandedSections([Object.keys(firstSection || {})[0]]);
              }}
            >
              {subject.name}
            </button>
          ))}
        </div>
      </div>

      {error && (
        <div className="alert alert-danger m-2 mb-0 d-flex align-items-center" role="alert">
          <AlertCircle size={20} className="me-2" />
          {error}
          <button className="btn-close ms-auto" onClick={() => setError(null)}></button>
        </div>
      )}

      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        {sidebarOpen && <div className="d-lg-none" onClick={() => setSidebarOpen(false)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 999 }} />}
        
        {/* Sidebar */}
        <div 
          className={`${sidebarOpen ? 'd-block' : 'd-none'} d-lg-block`}
          style={{ width: '250px', background: '#fff', borderRight: '1px solid #ddd', overflowY: 'auto', position: sidebarOpen ? 'fixed' : 'relative', top: sidebarOpen ? 0 : 'auto', bottom: sidebarOpen ? 0 : 'auto', left: 0, zIndex: 1000, height: '100%' }}
        >
          <div style={{ padding: '16px', background: subjects[selectedSubject]?.bg || '#f1f1f1', borderBottom: '1px solid #ddd' }}>
            <h5 style={{ color: subjects[selectedSubject]?.color, fontWeight: '700', margin: 0 }}>
              {subjects[selectedSubject]?.name} Tutorial
            </h5>
          </div>

          {Object.entries(currentSections).map(([sectionName, topics]) => (
            <div key={sectionName}>
              <div className="sidebar-section-title" onClick={() => toggleSection(sectionName)}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span>{sectionName}</span>
                  {expandedSections.includes(sectionName) ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                </div>
              </div>
              {expandedSections.includes(sectionName) && (
                <div>
                  {topics.map(topic => (
                    <div
                      key={topic}
                      className={`sidebar-item ${selectedTopic === topic ? 'active' : ''}`}
                      onClick={() => {
                        setSelectedTopic(topic);
                        if (window.innerWidth < 992) setSidebarOpen(false);
                      }}
                    >
                      {subjects[selectedSubject]?.name} {topic.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Main Content */}
        <div style={{ flex: 1, overflowY: 'auto', background: '#fff' }}>
          <div style={{ maxWidth: '900px', padding: '40px 20px', margin: '0 auto' }}>
            {loading ? (
              <div className="text-center py-5">
                <Loader size={48} className="text-success" style={{ animation: 'spin 1s linear infinite' }} />
                <p className="mt-3">Loading content from GitHub...</p>
              </div>
            ) : content ? (
              <>
                <button className="btn btn-success mb-3" onClick={goToPrevious} disabled={getTopicIndex() === 0}>
                  ❮ Previous
                </button>

                <h1 style={{ fontSize: '42px', fontWeight: '400', marginBottom: '20px' }}>{content.title}</h1>
                
                {content.sections?.map((section, index) => renderContent(section, index))}

                <div className="d-flex justify-content-between mt-5 pt-4">
                  <button className="btn btn-outline-success" onClick={goToPrevious} disabled={getTopicIndex() === 0}>
                    ❮ Previous
                  </button>
                  <button className="btn btn-success" onClick={goToNext} disabled={getTopicIndex() === getAllTopics().length - 1}>
                    Next ❯
                  </button>
                </div>
              </>
            ) : (
              <div className="alert alert-warning">
                <h4>Content Not Available</h4>
                <p>Please make sure your GitHub repository is set up correctly:</p>
                <ol>
                  <li>Create repository: <code>{GITHUB_CONFIG.repository}</code></li>
                  <li>Add folder: <code>content/{selectedSubject}/</code></li>
                  <li>Add file: <code>{selectedTopic}.json</code></li>
                </ol>
              </div>
            )}
          </div>
        </div>
      </div>

      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet" />
    </div>
  );
};

export default LearningHub;